import TooltipHelp from './TooltipHelp';

export default TooltipHelp;
